<template>
  <!-- 云现场 -->
  <div>
    <div class="top_img_content">
      <img class="top_img1" src="../../assets/img/yunxianchang.jpg" />
    </div>
    <div class="video_main" id="video_main">
      <div class="commonTitle">
        <h3 class="itemTitle" style="color:#4D6FFF">高清实时直连电镜屏幕，测试老师与您一对一</h3>
        <div class="subTitle">预约前务必提前沟通，预约热线400-168-0661</div>
      </div>
      <img class="cloud_img2" src="../../assets/img/cloud_img1.png" />
    </div>
        <div class="list_main">
      <div class="commonTitle">
        <h3 class="itemTitle itemTitleMargin">云现场项目</h3>
      </div>
      <div class="cardList">
        <el-row :gutter="70" type="flex" style="flex-wrap: wrap;">
          <el-col
            :xs="24"
            :sm="12"
            :md="12"
            :lg="6"
            :xl="6"
            v-for="(i,index) in equipList"
            :key="i+index +'a'"
          >
            <equipment-card
              :equipment="i"
              :image-prefix="imgurl"
              @details="detailsHandle"
              @action="toAppoint"
            />
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="test_flow">
      <div class="commonTitle">
        <h3 class="itemTitle itemTitleMargin">现场测试流程</h3>
        <div class="cardList">
          <div class="testList">
            <el-row :gutter="80" type="flex" style="flex-wrap: wrap;">
              <el-col v-for="item in testFlowList" :key="item.index" :span="6" class="test_col">
                <div class="flow_next">
                  <img src="../../assets/img/next.png" />
                </div>
                <div class="testFlow_card">
                  <img class="testFlow_img" :src="item.src" />
                  <div class="testFlow_Name">{{item.name}}</div>
                  <div class="testFlow_content">{{item.content}}</div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
      <div class="commonTitle">
        <h3 class="itemTitle itemTitleMargin">云现场测试流程</h3>
        <div class="cardList cloud_flow_list">
          <div class="testList">
            <el-row :gutter="80" type="flex" style="flex-wrap: wrap;">
              <el-col
                v-for="item in cloudTestFlowList"
                :key="item.index"
                :span="6"
                class="test_col"
              >
                <div class="flow_next">
                  <img src="../../assets/img/next.png" />
                </div>
                <div class="testFlow_card">
                  <img class="testFlow_img" :src="item.src" />
                  <div class="testFlow_Name">{{item.name}}</div>
                  <div class="testFlow_content">{{item.content}}</div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
    <div class="list_main testRemark">
      <div class="commonTitle">
        <h3 class="itemTitle itemTitleMargin">实验说明</h3>
      </div>
      <div class="testRemark_main" id="testRemark_main">
        <div class="testRemarkList" v-for="i in testRemarkList" :key="i.index">
          <div>
            <div class="testRemark_Index">{{i.index}}</div>
          </div>
          <div class="testRemark-content">{{i.content}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { equipList } from "@/api/request";
import equipmentCard from "@/components/equipmentCard.vue";
export default {
  components: {
    equipmentCard
  },
  data() {
    return {
      imgurl: process.env.VUE_APP_FILE_API,
      testFlowList: [
        {
          name: "沟通下单",
          content: "与客服沟通样品需求，确认样品满足现场测试需求并下单",
          src: require("../../assets/img/gtxd.png")
        },
        {
          name: "预约时间",
          content: "预约好具体测试时间，按照预约时间合理安排自己的行程",
          src: require("../../assets/img/yysj.png")
        },
        {
          name: "现场测试",
          content: "带上样品按照预约时间到现场测试，样品编号请尽量简洁",
          src: require("../../assets/img/xccs.png")
        },
        {
          name: "费用结算",
          content: "在测试完成后，根据测试时间长短进行费用的结算工作",
          src: require("../../assets/img/fyjs.png")
        }
      ],
      cloudTestFlowList: [
        {
          name: "沟通下单",
          content: "与客服沟通样品需求，确认样品满足现场测试需求并下单",
          src: require("../../assets/img/gtxd.png")
        },
        {
          name: "邮寄样品",
          content: "打印订单，和样品一起邮寄，样品编号请尽量用简单数字",
          src: require("../../assets/img/yjyp.png")
        },
        {
          name: "视频测试",
          content: "收到样品，约定好时间，通过腾讯会议进行云现场测试",
          src: require("../../assets/img/spcs.png")
        },
        {
          name: "费用结算",
          content: "在测试完成后，根据测试时间长短进行费用的结算工作",
          src: require("../../assets/img/fyjs.png")
        }
      ],
      equipList: [],
      testRemarkList: [
        {
          index: 1,
          content:
            "粉末，液体，薄膜，块体样品均可测试，粉末准备10mg，液体准备1ml，薄膜标记好测试面，块体尺寸：长宽最好≤10mm，高度最好≤5mm，并标记好测试面；样品需无放射性、无毒、无腐蚀性和无其他危险性。"
        },
        {
          index: 2,
          content:
            "云现场客户，为能及时联系您，请写清楚您的联系方式，测试时间会提前告知，请您安排好时间。若开始前20分钟联系不上您，我们可取消您的预约。若您无法参与已经预约的测试,请提前联系取消预约或更改时间。"
        },
        {
          index: 3,
          content:
            "具体收费项目包括:实验时长和制样部分。下单后客服会与您联系确认具体预约时长，最终收费按实际时长，多退少补。预约时长半小时起，半小时为节点；只有剩余时长超过半小时才会退费，退费以半小时为节点。"
        }
      ]
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      equipList({ isCloudScene: 1,pageSize: 8,pageNum: 1,isGrounding: 1,status: 1 }).then(res => {
        if (res.rows.length > 0) {
          this.equipList = res.rows.map(i=> {
            return {...i,imgUrl: i.fileList.length > 0 ? i.fileList[0].url : ''}
          });
        }
        
      });
    },
    detailsHandle(i) {
      this.$router.push({
        path: "/equipDetails",
        query: { id: i.id,type: this.$route.query.type ? this.$route.query.type : 0 }
      });
    },
    // 未登录时进入登录页，成功后继续打开当前设备的预约页面
    toAppoint(i) {
      const appointRoute = this.$router.resolve({
        path: "/appointPage",
        query: {
          id: i.id,
          type: this.$route.query.type ? this.$route.query.type : 0,
        },
      }).route.fullPath;
      if(this.$store.getters.token) {
        this.$router.push(appointRoute);
        return;
      }
      this.$router.push({
        path: "/login",
        query: {
          redirect: appointRoute,
        },
      });
    }
  }
};
</script>
<style scoped lang="scss">
.video_main {
  width: 70%;
  margin: 0 auto;
  padding-bottom: 50px;
}
.cloud_img2 {
  width: 100%;
}
.testFlow_Name {
  color: #333333;
  font-size: 18px;
  line-height: 27px;
  font-weight: 500;
}
.testFlow_content {
  color: #999999;
  font-size: 14px;
  line-height: 27px;
  height: 80px;
  margin-top: 20px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.test_flow {
  width: 100%;
  background: url("../../assets/img/flowbg.png") no-repeat;
  background-size: 100% 100%;
}
.testFlow_card {
  background: #fff;
  border-radius: 7px;
  text-align: center;
  padding: 30px;
}
.flow_next {
  img {
    width: 50%;
  }
  position: absolute;
  right: -60px;
  top: 45%;
}
.testFlow_img {
  width: 65%;
}
.testList {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
}
.test_col {
  position: relative;
}
.test_col:last-child .flow_next {
  display: none;
}
.cloud_flow_list {
  padding-bottom: 50px;
}
.testRemark {
  width: 100%;
  background: url("../../assets/img/tipsbg.png") no-repeat;
  background-size: 100% 100%;
  padding-bottom: 80px;
}
.testRemark_main {
  width: 80%;
  display: flex;
  flex-flow: column;
  margin: 0 auto;
}
.testRemark_Index {
  width: 30px;
  height: 30px;
  padding: 10px;
  border-radius: 50%;
  background: #4d6ffe;
  float: left;
  margin: 15px;
  font-size: 30px;
  color: #fff;
  text-align: center;
  line-height: 30px;
}
.testRemarkList {
  background: #fff;
  border-top-left-radius: 45px;
  border-bottom-left-radius: 45px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  height: 80px;
  margin-bottom: 40px;
  display: flex;
  flex-flow: row;
  align-items: center;
}
.testRemark-content {
  color: #333;
  font-size: 15px;
  margin-right: 20px;
}
</style>